PF.Dom.List = class DomList extends PF.Entity.Array
	{
	static get options()
		{
		return {
			models: undefined,
			modelsConfig: {filterConfig: {rule: ''}},
			itemClass: PF.List.Item,
			html: PF.Dom.List.templates,
			before: false
		};
		}

	static get templates()
		{
		return {
			//language=HTML
			// wrapper: `
			// 	<div class="pf-dom-list" pf="ul">
			// 	</div>
			// `,

			//language=HTML
			wrapper: `

				<div class="pf-dom-list" pf="ul">

				</divpf-dom-list>

			`,

		};
		}

	init()
		{
		if (this.models === undefined)
			{
			this.modelsConfig.list = this;
			this.models = new PF.Models(this.modelsConfig);
			}
		else
			{
			this.models.list = this;
			PF.Options.assignOptions(this.models, this.modelsConfig);
			}

		this.dom.collectHtml(this.dom.element, this.html);
		this.dom.loads(this.html);

		this.dom.element.append(this.dom.wrapper);


		this.models.on('addOne', this.addOneSlot.bind(this));
		this.models.on('remove', this.removeSlot.bind(this));

		this.on('addOne', (addedItem) => this.renderItem(addedItem));

		this.recreateList();
		}

	scrollSlot()
		{
		if (this.dom.scrollTarget.node.scrollTop > this.dom.scrollTarget.node.scrollHeight - 2 * this.dom.scrollTarget.height())
			{
			this.models.loadPart();
			}
		}

	recreateList()
		{
		for (let i = 0; i < this.models.length; i++)
			{
			let item = this.create(this.models[i]);
			this.splice(i, 0, item);
			}
		this.reindex();
		}

	addOneSlot(model)
		{
		let index = this.models.indexOf(model);

		let item = model.options.listItem;
		if (item === undefined)
			{
			item = this.create(model);
			}

		this.splice(index, 0, item);
		if (model.options.isNewRecord === true)
			{
			this.trigger('add-success', model, item);
			}
		this.reindex();
		}

	create(model)
		{
		return PF.H.create(this.itemClass, {list: this, model: model});
		}

	removeSlot(removedItems)
		{
		for (let i = 0; i < removedItems.length; i++)
			{
			for (let j = 0; j < this.length; j++)
				{
				if (PF.H.compareByPks(this[j].model, removedItems[i]))
					{
					this.splice(j, 1);
					break;
					}
				}
			}
		this.reindex();
		}

	renderItem(item)
		{
		this.trigger('beforeItemRender');
		item.dom.load(item.renderer, 'item');
		let index = this.indexOf(item);
		if (index === 0)
			{
			this.dom.ul.prepend(item.dom.item);
			}
		else
			{
				if (this.before === true) {
					this[index - 1].dom.item.before(item.dom.item);
				} else {
					this[index - 1].dom.item.after(item.dom.item);
				}
			}
		item.onRender();
		this.reindex();
		this.trigger('itemRendered');
		}

	reindex()
		{
		for (let i = 0; i < this.length; i++)
			{
			this[i].index = i;
			}
		}

	update(limit = this.length)
		{
		this.models.update(limit);
		}
	};


PF.Dom.List.Item = class Item extends PF.Widget
	{
	static get options()
		{
		return {
			list: undefined,
			index: undefined,
			model: undefined,
		};
		}

	init()
		{
		}

	get renderer()
		{
		return ``;
		}

	onRender()
		{
		this.dom.item.bindObject(this);
		this.bindDomFilter();
		}

	bindDomFilter()
		{
		this.bindDom({item: 'show'}, ['model.options.filterShow', 'model.options.removed'], (f, r) => {
			return f && (r !== true || this.list.showRemoved);
		});
		}

	};

